var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExternalyticsIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 55,
    viewBox: "0 0 67 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.6 45.5001L0 54.3001H51.8C55.9 54.3001 59.6 52.0001 61.5 48.4001L66.1 39.6001H14.3C10.2 39.6001 6.4 41.8001 4.6 45.5001Z",
    fill: "#C2C923"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6 6.20005L0 15H51.8C55.9 15 59.6 12.7 61.5 9.10005L66.1 0.300049H14.3C10.2 0.300049 6.4 2.60005 4.6 6.20005Z",
    fill: "#1C2743"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6 25.9L0 34.7H51.8C55.9 34.7 59.6 32.4 61.5 28.8L66.1 20H14.3C10.2 19.9 6.4 22.2 4.6 25.9Z",
    fill: "#08A2AA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalyticsIco);
export default __webpack_public_path__ + "static/media/externalytics_ico.a6f5af59c1296a18bd44352ed4be58be.svg";
export { ForwardRef as ReactComponent };